import { Alert, AlertTitle, Grid, Paper, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomTextField from "../CustomComponents/CustomTextField";
import { SecurityChequeReducerAction } from "../Store/SecurityCheque/SecurityChequeReducer";

const FileDetailsInfo = (props) => {
  const fileDetailsData = useSelector(
    (state) => state.securityCheque.fileDetailsData
  );

  return (
    <React.Fragment>
      <Paper
        sx={{
          padding: "0px 16px 8px 16px",
          marginBottom: "0px !important",
        }}
      >
        <h4>{"File Details Information"}</h4>
        <Grid container rowSpacing={0} columnSpacing={1}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="applicationNum"
              label="Application Number"
              variant="standard"
              disabled={true}
              required={false}
              value={fileDetailsData.applicationNum}
            ></CustomTextField>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomDateField
              type="emiStartDate"
              label="EMI Start Date"
              variant="standard"
              disabled={true}
              value={fileDetailsData.emiStartDate}
            ></CustomDateField>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomDateField
              type="fbdday"
              label="FBD Day"
              variant="standard"
              disabled={true}
              value={fileDetailsData.fbdDay}
            ></CustomDateField>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomDateField
              type="ecdduedate"
              label="ECD Due Date"
              variant="standard"
              disabled={true}
              value={fileDetailsData.emiDueDate}
            ></CustomDateField>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              type="text"
              label="EMI Amount"
              variant="standard"
              disabled={true}
              value={
                fileDetailsData.emiAmt === "0"
                  ? 0
                  : parseInt(fileDetailsData.emiAmt).toLocaleString("en-IN")
              }
            ></CustomTextField>
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};

export default FileDetailsInfo;
